// SPDX-License-Identifier: MIT
import type { Session } from '@supabase/supabase-js';

// True when a user landing on `/` should be redirected to `/welcome` instead
// of seeing the logged-out marketing landing. Returns false when there is no
// session, or when an MCP "Connect my Claude" return_to is in play (the
// existing handoff path in mountLanding takes precedence — completeMcpHandoff
// will redirect away to the MCP /authorize URL itself).
//
// Bug 5 fix 2026-05-28 : mountLanding used to render the logged-out landing
// unconditionally, so an authed user returning via the logo (or a stale tab)
// was forced to re-login when they clicked any CTA. Extracted here for
// testability — the route handler stays a single thin glue layer.
export function shouldRedirectAuthedToWelcome(
  session: Session | null,
  returnTo: string | null,
): boolean {
  if (!session) return false;
  if (returnTo) return false; // MCP handoff path owns this case
  return true;
}
